import { styled } from 'styled-components'

import { Typography } from '../../../Typography'

export const StyledContainer = styled.div`
  display: flex;
  width: fit-content;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const StyledUserData = styled.div`
  display: flex;
  overflow: hidden;
  max-width: 100%;
  flex: 1;
  flex-direction: column;
`

export const StyledUserName = styled(Typography)`
  overflow: hidden;
  padding: 1px 0;
  color: ${({ theme }) => theme.colors['N Content/Secondary']};
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StyledLogoutLink = styled(Typography)`
  align-self: flex-end;
  color: ${({ theme }) => theme.colors['N Content/Tertiary']};
  cursor: pointer;
  text-decoration: underline;
`
